import { render, staticRenderFns } from "./UpdateAgreementConsentModal.vue?vue&type=template&id=f4a2dea4&"
import script from "./UpdateAgreementConsentModal.vue?vue&type=script&lang=js&"
export * from "./UpdateAgreementConsentModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports